import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  Input,
  HostListener,
  inject,
} from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);
  private overlayContainer = inject(OverlayContainer);

  @Input() ignoreOverlay = false; // NEW: allow disabling overlay check
  @Output() clickOutside = new EventEmitter<void>();

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement): void {
    const clickedInsideHost = this.elementRef.nativeElement.contains(target);
    const clickedInsideOverlay = this.overlayContainer
      .getContainerElement()
      .contains(target);

    const shouldIgnoreOverlay = this.ignoreOverlay || !clickedInsideOverlay;

    if (!clickedInsideHost && shouldIgnoreOverlay) {
      this.clickOutside.emit();
    }
  }
}
